import { fetchPost } from '@/entities/post/api';
import { SocialPostsGrid } from '@/features/(insight)/posts/ui/social-post-card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/shadcn/dialog';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';
import { useQuery } from '@tanstack/react-query';

type Props = {
  title: string;
  postIds: string[];
  isOpen: boolean;
  onClose: () => void;
};

export const CitePostsDialog = ({ title, postIds, isOpen, onClose }: Props) => {
  const { workspaceId } = useWorkspaceId();

  const { data, isPending } = useQuery({
    queryKey: ['post-list', ...postIds],
    queryFn: async ({ signal }) => {
      const promises = postIds.map((id) => {
        return fetchPost(workspaceId, id, signal);
      });
      const res = await Promise.all(promises);
      return {
        posts: res,
      };
    },
  });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-250 max-w-250! gap-0 p-0">
        <DialogHeader className="border-b border-gray-200 p-6">
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="max-h-[70vh] overflow-y-auto" style={{ scrollbarGutter: 'stable' }}>
          <div className="space-y-4">
            <SocialPostsGrid
              className="pr-2"
              posts={
                data?.posts.map((p) => ({
                  ...p,
                  board_count: p.boards?.length || 0,
                })) ?? []
              }
              isLoading={isPending}
              isFetchingNextPage={false}
              hasNextPage={false}
              onLoadMore={() => {}}
              skeletonCount={3}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
